import React from "react";
import styled from 'styled-components';
import "react-step-progress-bar/styles.css";

const Container = styled.div`
  width: 100%;
  background: #fff;
`;

const SubTitle = styled.div`
    font-style: ${props => props.style ? props.style : "normal"};
    font-variant: normal
    font-weight: ${props => props.weight ? props.weight : "normal"};
    font-stretch: normal
    font-size: ${props => props.fontSize ? props.fontSize : "12px"};
    line-height: normal
    font-family: Roboto
    margin: ${props => props.margin ? props.margin : "0rem 0rem 0rem 0rem"};
    padding: ${props => props.padding ? props.padding : "0rem 0rem 0rem 0rem"};
    display: ${props => props.display ? props.display : "block"};
    color: ${props => props.color ? props.color : "#000000"};
    text-align: 
    ${props => props.center ? "center" : ""}
    ${props => props.right ? "right" : ""}
    ${props => props.left ? "left" : ""}
    ;
`;

const InputSubtitleClaroSocio = ({text, subTitleStyle, fontSize}) => {
    return(
        <Container>
            {
                subTitleStyle ? 
                    <SubTitle  
                        {...subTitleStyle.align} 
                        {...subTitleStyle.weight} 
                        {...subTitleStyle.style} 
                        {...subTitleStyle.style} 
                        color = {subTitleStyle.color && subTitleStyle.color}
                        margin = {subTitleStyle.margin && subTitleStyle.margin}
                        fontSize = {fontSize}
                    >
                        {text}
                    </SubTitle> : 
                    <></>
            }
        </Container>
    )
}

export default InputSubtitleClaroSocio;